exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-corner[data-v-5f4e3050]{border-start-start-radius:20px;border-end-end-radius:20px}", ""]);

// exports
